export default __webpack_public_path__ + "static/media/MAN.661bf338.png";